const LOGO_BASE = "/icons"

export type LogoVariant = "color" | "bw"

export type LogoKey =
  | "sharing-direct"
  | "sharing-collaborative"
  | "sharing-federated"
  | "sharing-tre"
  | "commercial-yes"
  | "commercial-no"
  | "sharing-onward"
  | "sharing-no-onward"
  | "share-alike"
  | "modifications-no"
  | "benefit-sharing"
  | "cost-recovery"
  | "publication-yes"
  | "publication-embargo"
  | "publication-review"
  | "publication-no"
  | "aggregated-data-reporting"
  | "attribution-yes"
  | "attribution-no"
  | "attribution-outputs"
  | "attribution-author"

type LogoMeta = {
  title: string
  file: string
}

export const LOGO_ICON_CLASS = "h-12 w-12 object-contain"

export const logoMeta: Record<LogoKey, LogoMeta> = {
  "sharing-direct": { title: "Direct sharing", file: "sharing-direct.svg" },
  "sharing-collaborative": {
    title: "Collaborative sharing",
    file: "sharing-collaborative.svg"
  },
  "sharing-federated": { title: "Federated analysis", file: "sharing-federated.svg" },
  "sharing-tre": { title: "Trusted research environment", file: "sharing-tre.svg" },
  "commercial-yes": { title: "Commercial use permitted", file: "commercial-yes.svg" },
  "commercial-no": { title: "No commercial use", file: "commercial-no.svg" },
  "sharing-onward": { title: "Onward sharing allowed", file: "sharing-onward.svg" },
  "sharing-no-onward": { title: "No onward sharing", file: "sharing-no-onward.svg" },
  "share-alike": { title: "Share-alike required", file: "share-alike.svg" },
  "modifications-no": {
    title: "No derivatives/modifications",
    file: "modifications-no.svg"
  },
  "benefit-sharing": { title: "Benefit-sharing required", file: "benefit-sharing.svg" },
  "cost-recovery": { title: "Cost recovery required", file: "cost-recovery.svg" },
  "publication-yes": { title: "Publication allowed", file: "publication-yes.svg" },
  "publication-embargo": { title: "Publication under embargo", file: "publication-embargo.svg" },
  "publication-review": { title: "Publication requires review", file: "publication-review.svg" },
  "publication-no": { title: "Publication not permitted", file: "publication-no.svg" },
  "aggregated-data-reporting": {
    title: "Aggregated data reporting",
    file: "aggregated-data-reporting.svg"
  },
  "attribution-yes": { title: "Attribution required", file: "attribution-yes.svg" },
  "attribution-no": { title: "No attribution required", file: "attribution-no.svg" },
  "attribution-outputs": {
    title: "Attribution required on outputs",
    file: "attribution-yes.svg"
  },
  "attribution-author": { title: "Authorship required", file: "attribution-author.svg" }
}

export const getLogoUrl = (key: LogoKey, variant: LogoVariant = "color"): string =>
  `${LOGO_BASE}/${variant}/${logoMeta[key].file}`

const rawCache = new Map<string, Promise<string>>()

export const fetchLogoRaw = (key: LogoKey, variant: LogoVariant = "color"): Promise<string> => {
  const cacheKey = `${variant}-${key}`
  if (rawCache.has(cacheKey)) return rawCache.get(cacheKey) as Promise<string>

  const url = getLogoUrl(key, variant)
  const promise = fetch(url)
    .then(response => (response.ok ? response.text() : ""))
    .catch(() => "")

  rawCache.set(cacheKey, promise)
  return promise
}
